module.exports = __webpack_public_path__ + "static/media/cplusplus.8f42e018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/cplusplus.png
// module id = 90
// module chunks = 0